/* The one composer for people Chat and the agents (chat makeover #2718) */
.container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-style: solid;
  border-color: var(--tuna-palette-divider);
  background-color: var(--tuna-palette-action-hover);
  border-width: 1px;
  border-radius: var(--tuna-shape-radius-md);
}

/*
 * Composer focus ring accent (Joni §2). Neutral fallback keeps the human
 * Chat tool, which never sets `--agent-accent`, byte-identical.
 */
.container:focus-within {
  box-shadow: 0 0 0 2px var(--agent-accent, var(--tuna-focus-ring, transparent));
  border-radius: var(--tuna-shape-radius-sm);
}

.focus {
  display: flex;
}

/*
 * Stacked (GH #3161, option A): the field spans the composer's width. Two lines to start, growing to six, then
 * scrolling. body1 (1rem, 16px) everywhere: the field must be at least 16px on phones, or iOS zooms into it on focus.
 */
.editor {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 4px;
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  min-height: calc(2 * 1.5em);
  max-height: calc(6 * 1.5em);
  overflow-y: auto;
}

/* One slim row under the field: the Task chip, the hint, and Send at the end */
.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.hint {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

/* T1: a checkbox icon and its label, in a pill; filled, with a primary edge, when on */
.actions .taskChip {
  flex-shrink: 0;
  gap: var(--tuna-spacing-0_5);
  min-height: 36px;
  padding: 0 10px 0 8px;
  border-radius: var(--tuna-shape-radius-pill);
}

.actions .taskChip[aria-pressed='true'] {
  border-color: var(--tuna-palette-primary-main);
  font-weight: var(--tuna-typography-fontWeight-bold);
}

/* Send: a round button with an up arrow, at least 36px */
.actions .send {
  flex: none;
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 0;
  border-radius: var(--tuna-shape-radius-circle);
}

/* 44px targets on touch */
@media (pointer: coarse) {
  .actions :is(button) {
    min-height: 44px;
    min-width: 44px;
  }

  .actions .send {
    width: 44px;
    height: 44px;
  }
}
